/**
 * 热搜服务
 * 封装热搜相关的 API 调用
 */
import { get } from './apiClient';

/**
 * 获取指定平台的热搜数据
 * @param {string} platform 平台名称
 * @param {boolean} refresh 是否强制刷新
 * @returns {Promise} 热搜数据
 */
export const getHotSearchByPlatform = async (platform, refresh = false) => {
  try {
    const params = refresh ? { refresh: 'true' } : {};
    const response = await get(`/hot-search/${platform}`, { params });
    return response;
  } catch (error) {
    console.error(`获取 ${platform} 热搜数据失败:`, error);
    throw error;
  }
};

/**
 * 获取所有平台的热搜数据
 * @param {boolean} refresh 是否强制刷新
 * @returns {Promise} 所有平台热搜数据
 */
export const getAllHotSearch = async (refresh = false) => {
  try {
    const params = refresh ? { refresh: 'true' } : {};
    const response = await get('/hot-search', { params });
    return response;
  } catch (error) {
    console.error('获取所有热搜数据失败:', error);
    throw error;
  }
};

/**
 * 获取支持的平台列表
 * @returns {Promise} 支持的平台列表
 */
export const getSupportedPlatforms = async () => {
  try {
    const response = await get('/hot-search/platforms');
    return response;
  } catch (error) {
    console.error('获取支持平台列表失败:', error);
    throw error;
  }
};

/**
 * 获取热搜数据统计信息
 * @returns {Promise} 统计信息
 */
export const getHotSearchStats = async () => {
  try {
    const response = await get('/hot-search/stats');
    return response;
  } catch (error) {
    console.error('获取热搜统计信息失败:', error);
    throw error;
  }
};

/**
 * 清除指定平台的缓存
 * @param {string} platform 平台名称
 * @returns {Promise} 清除结果
 */
export const clearPlatformCache = async (platform) => {
  try {
    const response = await get(`/hot-search/${platform}/cache`, { method: 'DELETE' });
    return response;
  } catch (error) {
    console.error(`清除 ${platform} 平台缓存失败:`, error);
    throw error;
  }
};

/**
 * 清除所有平台缓存
 * @returns {Promise} 清除结果
 */
export const clearAllCache = async () => {
  try {
    const response = await get('/hot-search/cache', { method: 'DELETE' });
    return response;
  } catch (error) {
    console.error('清除所有缓存失败:', error);
    throw error;
  }
};

/**
 * 手动刷新指定平台数据
 * @param {string} platform 平台名称
 * @returns {Promise} 刷新结果
 */
export const refreshPlatformData = async (platform) => {
  try {
    const response = await get(`/hot-search/${platform}/refresh`, { method: 'POST' });
    return response;
  } catch (error) {
    console.error(`刷新 ${platform} 平台数据失败:`, error);
    throw error;
  }
};

/**
 * 手动刷新所有平台数据
 * @returns {Promise} 刷新结果
 */
export const refreshAllData = async () => {
  try {
    const response = await get('/hot-search/refresh', { method: 'POST' });
    return response;
  } catch (error) {
    console.error('刷新所有平台数据失败:', error);
    throw error;
  }
}; 